import React from 'react';
export function ScheduleNotes() {
  return <div className="mt-12 bg-paper p-8 rounded-2xl border border-subtle-gray" data-id="element-2960">
      <h3 className="text-2xl text-ink mb-4" data-id="element-2961">Important Notes</h3>
      <ul className="flex flex-col gap-3 text-gray-warm" data-id="element-2962">
        <li data-id="element-2963">• Please arrive 10 minutes before your scheduled class time.</li>
        <li data-id="element-2964">
          • Trial students should wear comfortable athletic clothing (no zippers
          or buttons).
        </li>
        <li data-id="element-2965">• Bring a water bottle.</li>
        <li data-id="element-2966">
          • Class times are subject to change. We will confirm your exact class
          time when you claim your free week.
        </li>
      </ul>
    </div>;
}